var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20L16.4444 16.4444M18.2222 11.1111C18.2222 12.9971 17.473 14.8058 16.1394 16.1394C14.8058 17.473 12.9971 18.2222 11.1111 18.2222C9.22513 18.2222 7.41639 17.473 6.0828 16.1394C4.7492 14.8058 4 12.9971 4 11.1111C4 9.22513 4.7492 7.41639 6.0828 6.0828C7.41639 4.7492 9.22513 4 11.1111 4C12.9971 4 14.8058 4.7492 16.1394 6.0828C17.473 7.41639 18.2222 9.22513 18.2222 11.1111Z",
    stroke: "#717680",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch24Px);
export default __webpack_public_path__ + "static/media/Search_24px.77da143ea40d1276bec0405b8fae6b5a.svg";
export { ForwardRef as ReactComponent };